import { Link } from 'react-router-dom';
import { Bell, Gift, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function KeepsakesHeader({ darkMode }) {
  // Confetti dots data - fixed positions to prevent flickering
  const confettiDots = [
    { w: 6, h: 6, bg: '#E8B4B8', top: 15, left: 12, opacity: 0.25, delay: 0.5 },
    { w: 5, h: 5, bg: '#B4D4E8', top: 25, left: 85, opacity: 0.3, delay: 1 },
    { w: 7, h: 7, bg: '#C8E8B4', top: 45, left: 22, opacity: 0.2, delay: 0 },
    { w: 4, h: 4, bg: '#FED7A5', top: 55, left: 78, opacity: 0.35, delay: 1.5 },
    { w: 6, h: 6, bg: '#9E6752', top: 70, left: 35, opacity: 0.25, delay: 0.8 },
    { w: 5, h: 5, bg: '#E8B4B8', top: 82, left: 65, opacity: 0.3, delay: 0.3 },
    { w: 7, h: 7, bg: '#B4D4E8', top: 35, left: 55, opacity: 0.2, delay: 1.2 },
    { w: 4, h: 4, bg: '#C8E8B4', top: 62, left: 8, opacity: 0.35, delay: 0.6 },
    { w: 6, h: 6, bg: '#FED7A5', top: 18, left: 48, opacity: 0.25, delay: 1.8 },
    { w: 5, h: 5, bg: '#9E6752', top: 88, left: 92, opacity: 0.3, delay: 0.2 },
    { w: 7, h: 7, bg: '#E8B4B8', top: 42, left: 72, opacity: 0.2, delay: 1.4 },
    { w: 4, h: 4, bg: '#B4D4E8', top: 78, left: 18, opacity: 0.35, delay: 0.9 },
    { w: 6, h: 6, bg: '#C8E8B4', top: 52, left: 42, opacity: 0.25, delay: 0.4 },
    { w: 5, h: 5, bg: '#FED7A5', top: 28, left: 68, opacity: 0.3, delay: 1.6 },
    { w: 7, h: 7, bg: '#9E6752', top: 65, left: 88, opacity: 0.2, delay: 0.7 }
  ];

  return (
    <div className="relative py-16 sm:py-20 overflow-hidden" style={{ background: 'linear-gradient(135deg, #534145 0%, #20212B 100%)' }}>
      {/* Decorative floating gifts */}
      <div className="absolute top-10 left-10 animate-bounce" style={{ animationDuration: '3s', animationDelay: '0s' }}>
        <div className="w-16 h-16 rounded-xl rotate-12" style={{ background: 'linear-gradient(135deg, #E8B4B8 0%, #D4A4A8 100%)', boxShadow: '0 4px 20px rgba(232,180,184,0.4)' }}>
          <div className="absolute top-0 left-1/2 w-2 h-full -translate-x-1/2" style={{ background: '#FED7A5' }} />
          <div className="absolute top-1/2 left-0 w-full h-2 -translate-y-1/2" style={{ background: '#FED7A5' }} />
        </div>
      </div>
      
      <div className="absolute top-20 right-20 animate-bounce" style={{ animationDuration: '2.5s', animationDelay: '0.5s' }}>
        <div className="w-12 h-12 rounded-lg -rotate-12" style={{ background: 'linear-gradient(135deg, #B4D4E8 0%, #A4C4D8 100%)', boxShadow: '0 4px 20px rgba(180,212,232,0.4)' }}>
          <div className="absolute top-0 left-1/2 w-1.5 h-full -translate-x-1/2" style={{ background: '#FED7A5' }} />
          <div className="absolute top-1/2 left-0 w-full h-1.5 -translate-y-1/2" style={{ background: '#FED7A5' }} />
        </div>
      </div>

      <div className="absolute bottom-10 left-1/4 animate-bounce" style={{ animationDuration: '2.8s', animationDelay: '1s' }}>
        <div className="w-10 h-10 rounded-lg rotate-45" style={{ background: 'linear-gradient(135deg, #C8E8B4 0%, #B8D8A4 100%)', boxShadow: '0 4px 20px rgba(200,232,180,0.4)' }}>
          <div className="absolute top-0 left-1/2 w-1.5 h-full -translate-x-1/2" style={{ background: '#FED7A5' }} />
          <div className="absolute top-1/2 left-0 w-full h-1.5 -translate-y-1/2" style={{ background: '#FED7A5' }} />
        </div>
      </div>

      <div className="absolute bottom-20 right-1/3 animate-bounce" style={{ animationDuration: '3.2s', animationDelay: '0.3s' }}>
        <div className="w-14 h-14 rounded-xl -rotate-6" style={{ background: 'linear-gradient(135deg, #D4B4E8 0%, #C4A4D8 100%)', boxShadow: '0 4px 20px rgba(212,180,232,0.4)' }}>
          <div className="absolute top-0 left-1/2 w-2 h-full -translate-x-1/2" style={{ background: '#FED7A5' }} />
          <div className="absolute top-1/2 left-0 w-full h-2 -translate-y-1/2" style={{ background: '#FED7A5' }} />
        </div>
      </div>

      {/* Sparkle elements */}
      <div className="absolute top-1/4 right-1/4">
        <Sparkles className="w-6 h-6 text-[#FED7A5] animate-pulse" style={{ animationDuration: '2s' }} />
      </div>
      <div className="absolute bottom-1/4 left-1/3">
        <Sparkles className="w-5 h-5 text-[#FED7A5] animate-pulse" style={{ animationDuration: '1.5s', animationDelay: '0.5s' }} />
      </div>
      <div className="absolute top-1/3 left-1/4">
        <Sparkles className="w-4 h-4 text-[#FED7A5] animate-pulse" style={{ animationDuration: '1.8s', animationDelay: '0.8s' }} />
      </div>

      {/* Confetti dots */}
      {confettiDots.map((dot, i) => (
        <div
          key={`confetti-${i}`}
          className="absolute rounded-full"
          style={{
            width: `${dot.w}px`,
            height: `${dot.h}px`,
            background: dot.bg,
            top: `${dot.top}%`,
            left: `${dot.left}%`,
            opacity: dot.opacity,
            animation: `float ${3 + (i % 3)}s ease-in-out infinite`,
            animationDelay: `${dot.delay}s`
          }}
        />
      ))}
      
      <div className="max-w-6xl mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="relative">
            <h1 className="text-5xl sm:text-6xl mb-4 leading-tight relative inline-block" style={{ fontFamily: 'Playfair Display, serif', color: 'white', fontWeight: '700' }}>
              Keepsakes
              <div className="absolute -bottom-2 left-0 right-0 h-1.5 rounded-full" style={{ background: 'linear-gradient(90deg, #FED7A5 0%, #9E6752 50%, #FED7A5 100%)' }} />
            </h1>
            <p className="text-base sm:text-lg leading-relaxed mt-6" style={{ color: 'rgba(255,255,255,0.9)', maxWidth: '500px' }}>
              <Gift className="inline w-5 h-5 mr-2 mb-1" style={{ color: '#FED7A5' }} />
              Collect and treasure gift ideas for everyone you love
            </p>
          </div>
          <div className="flex gap-3">
            <Link to="/profile">
              <Button
                className="flex items-center space-x-2 transition-all hover:scale-105"
                style={{ background: 'rgba(255,255,255,0.2)', color: 'white', borderRadius: '30px', padding: '16px 24px', fontSize: '16px', backdropFilter: 'blur(10px)' }}
              >
                <Bell className="w-5 h-5" />
                <span className="hidden sm:inline">Reminder Settings</span>
                <span className="sm:hidden">Reminders</span>
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
}
